/* Lifecykel scroll-reveal — load once (guarded). Defer-loaded; non-blocking.
   Adds .is-in when a .lc-reveal element scrolls into view. */
(function () {
  if (window.__lcReveal) return; window.__lcReveal = true;
  var root = document.documentElement;
  if (!('IntersectionObserver' in window)) return;           // old browsers: content stays visible
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) return;                               // reduced motion: no hiding, no animation
  root.classList.add('lc-reveal-on');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
  function scan(ctx) {
    (ctx || document).querySelectorAll('.lc-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', function(){ scan(); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); }); // theme editor
})();
